export default __webpack_public_path__ + "static/media/6.58644ff2.png";